var FeatureCategories;
(function (FeatureCategories) {
    FeatureCategories["Explore"] = "Explore";
    FeatureCategories["Socialize"] = "Socialize";
    FeatureCategories["Achieve"] = "Achieve";
    FeatureCategories["PowerUps"] = "Power-Ups";
})(FeatureCategories || (FeatureCategories = {}));
export default FeatureCategories;
//# sourceMappingURL=FeatureCategories.js.map